<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <h3>{{ $route.meta.title }}</h3>
    <layout-panel hide-collapse>
      <template #header>基础信息</template>
      <el-form label-width="120px"
               label-position="top"
               size="medium">
        <div class="re-el-form__triple_grid">
          <el-form-item label="零工ID">
            <div class="form-item__detail">{{detail.userid}}</div>
          </el-form-item>
          <el-form-item label="手机号">
            <div class="form-item__detail">{{detail.cellphone}}</div>
          </el-form-item>
          <el-form-item label="省市区">
            <div class="form-item__detail">{{regionText}}</div>
          </el-form-item>
          <el-form-item label="累计完单数">
            <div class="form-item__detail">{{detail.total_pass_order_count}}</div>
          </el-form-item>
          <el-form-item label="工单失效率">
            <div class="form-item__detail">
              <span :class="{ 'is-risk': isHighInvalidPercent(detail) }">{{totalInvalidPercentText}}</span>
            </div>
          </el-form-item>
          <el-form-item label="风险状态">
            <div class="form-item__detail">
              <span :class="{ 'is-risk': isRiskStatus(detail)}">{{riskStatusText}}</span>
            </div>
          </el-form-item>
          <el-form-item label="确认状态">
            <div class="form-item__detail">{{confirmStatusText}}</div>
          </el-form-item>
          <el-form-item label="负责人">
            <div class="form-item__detail">{{adminusernameText}}</div>
          </el-form-item>
          <el-form-item label="确认时间">
            <div class="form-item__detail">{{detail.confirmed_at}}</div>
          </el-form-item>
          <el-form-item label="风险触发条件" v-if="Number(detail.risk_status) === 1">
            <div class="form-item__detail">
              {{riskReasons.join(',')}}
            </div>
          </el-form-item>
          <el-form-item label="触发风险时间">
            <div class="form-item__detail">
              {{detail.became_risk_at}}
            </div>
          </el-form-item>
        </div>
        <div class="re-el-form_single_grid">
          <el-form-item label="单一客户完单率"
                        class="risk-user-customer-stats-item">
            <div class="risk-user-customer-stats">
              <div v-for="(item, index) in detail.customer_stats"
                   :class="{ 'is-risk': isCustomerRisk(item) }"
                   :key="index">
                <span style="display: inline-block;min-width: 200px">{{ item.customername }}</span>
                <span>{{item.order_percent}}%</span>
              </div>
            </div>
          </el-form-item>
        </div>
        <div class="re-el-form_single_grid">
          <el-form-item label="备注"
                        required
                        v-if="detail.risk_status === 1">
            <el-input v-model="remark"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入备注信息"
                      maxlength="500"
                      show-word-limit />
          </el-form-item>
        </div>
        <div class="re-el-form__flex">
          <el-form-item v-if="detail.risk_status === 1">
            <el-button type="danger"
                       :loading="confirmLoading"
                       @click="onConfirmRisk">确认风险</el-button>
            <el-button type="success"
                       :loading="confirmLoading"
                       @click="onConfirmNormal">确认正常</el-button>
            <el-button @click="$router.push('/users/riskusers')">返回列表</el-button>
          </el-form-item>
        </div>
      </el-form>
    </layout-panel>
    <layout-panel hide-collapse>
      <template #header>确认日志</template>
      <el-table :data="confirmLogList" >
        <el-table-column prop="logtime"
                         label="操作时间" />
        <el-table-column prop="adminusername"
                         label="操作人" >
          <template v-slot="scope">
            {{scope.row.adminusername}} / {{scope.row.adminuserid}}
          </template>
        </el-table-column>
        <el-table-column prop="logtype"
                         label="日志类型"  />
        <el-table-column prop="logcontent"
                         label="日志内容"
                         show-overflow-tooltip />
      </el-table>
    </layout-panel>
  </div>
</template>

<script>
import userRiskMixins from '@views/users/user-risk.mixins'

export default {
  mixins: [userRiskMixins],
  data () {
    return {
      id: this.$route.params.id,
      detail: {
        userid: null,
        cellphone: null,
        province_name: null,
        city_name: null,
        area_name: null,
        risk_status: null,
        confirm_status: null,
        total_pass_order_count: null,
        total_invalid_percent: null,
        confirmed_adminusername: '',
        confirmed_adminuserid: '',
        confirmed_logs: [],
        customer_stats: [],
        confirmed_at: null,
        became_risk_at: null,
        config: {
          risk_customer_confirm_percent: 0,
          risk_invalid_percent: 0,
        }
      },
      remark: '',
      confirmLoading: false,
    }
  },
  computed: {
    ...Vuex.mapState({
      riskusersOpts: state => state.users.riskusersOpts,
    }),
    regionText () {
      const d = this.detail
      if (!d || !d.userid) {
        return ''
      }
      return `${d.province_name || ''}${d.city_name || ''}${d.area_name || ''}`
    },
    totalInvalidPercentText () {
      const val = this.detail.total_invalid_percent
      return val === null || val === undefined || val === '' ? '' : `${val}%`
    },
    riskStatusText () {
      return this.riskusersOpts.riskStatusOpts[this.detail.risk_status] || ''
    },
    confirmStatusText () {
      return this.riskusersOpts.riskConfirmStatusOpts[this.detail.confirm_status] || ''
    },
    riskReasons () {
      let reasons = []
      if (Number(this.detail.risk_status) !== 1) {
        return reasons
      }
      if (this.detail.customer_stats.find(it => it.order_percent >= this.detail.config.risk_customer_confirm_percent)) {
        reasons.push('单一客户完单率')
      }
      if (this.detail.total_invalid_percent >= this.detail.config.risk_invalid_percent) {
        reasons.push('工单失效率')
      }
      return reasons
    },
    adminusernameText () {
      if (!this.detail.confirmed_adminuserid) {
        return ''
      }
      return this.detail.confirmed_adminusername + ' / ' + this.detail.confirmed_adminuserid
    },
    confirmLogList () {
      return this.detail.confirmed_logs.reverse()
    }
  },
  created () {
    this.setDetailData()
  },
  methods: {
    setDetailData () {
      request.common('getRiskUserDetail', { userid: this.id }).then(({ data }) => {
        filter.setLoop(this.detail, data)
      })
    },
    onConfirmRisk () {
      this.$confirm('确认将该零工标记为风险用户？', '确认风险', { type: 'warning' }).then(() => {
        this.submitConfirm(1)
      }).catch(() => {})
    },
    onConfirmNormal () {
      this.$confirm('确认将该零工标记为正常用户？', '确认正常', { type: 'warning' }).then(() => {
        this.submitConfirm(2)
      }).catch(() => {})
    },
    submitConfirm (riskStatus) {
      this.confirmLoading = true
      request.common('confirmRiskUser', {
        userid: this.id,
        risk_status: riskStatus,
        remark: this.remark,
      }).then(() => {
        this.$message.success('确认成功')
        this.setDetailData()
      }).finally(() => {
        this.confirmLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.form-item__detail {
  border: 1px solid #E4E7ED;
  background: #F5F7FA;
  border-radius: 4px;
  padding: 0 10px;
  height: 38px;
}
.risk-user-customer-stats {
  min-height: 36px;
  line-height: 36px;
  font-size: 14px;
  padding: 10px;
  color: #606266;
  background: #F5F7FA;
  border: 1px solid #E4E7ED;
  border-radius: 5px;
}

.is-risk {
  color: #f56c6c !important;
}
.re-el-form__triple_grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 20px;

  .el-form-item {
    margin-bottom: 0 !important;
  }

  >>> .el-form-item__label {
    font-weight: bold;
  }
}
.re-el-form_single_grid {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;

  >>> .el-form-item__label {
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/users/pages/detail/RiskUserDetail.vue